module.exports = __webpack_public_path__ + "static/media/5. Nurul.eff98096.png";